import {Component, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {CustomerPortalService} from "../customer-portal.service";

@Component({
    selector: "fhm-customer-portal-page",
    styleUrls: ["./customer-portal-page.component.scss"],
    templateUrl: "./customer-portal-page.component.html",
    providers: [CustomerPortalService],
    standalone: false
})
export class CustomerPortalPageComponent implements OnInit {

    constructor(private auth: AuthApiService,
                private customerPortalService: CustomerPortalService) {
    }

    ngOnInit(): void {
        const token: string = this.customerPortalService.getUrlParameter("d");
        this.auth.signInUsingSignUpToken(token);
    }
}
